// import React, { useState, useEffect } from "react";
// import { db } from "../firebase"; // Firebase configuration
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom"; // Import navigation hook
// import { toast } from "react-toastify";

// const ViewResults = () => {
//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState(""); // Search term state
//     const navigate = useNavigate(); // Initialize the navigation hook

//     useEffect(() => {
//         const fetchUsersAndQuizzes = async () => {
//             setLoading(true);
//             try {
//                 const usersCollectionRef = collection(db, "users");
//                 const usersSnapshot = await getDocs(usersCollectionRef);

//                 const usersData = await Promise.all(
//                     usersSnapshot.docs.map(async (userDoc) => {
//                         const userId = userDoc.id;
//                         const userInfo = userDoc.data();

//                         // Fetch quizzes for the user
//                         const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
//                         const quizzesSnapshot = await getDocs(quizzesCollectionRef);

//                         // Process quiz data
//                         const quizzes = await Promise.all(
//                             quizzesSnapshot.docs.map(async (quizDoc) => {
//                                 const quizData = quizDoc.data();

//                                 // Fetch training details
//                                 const fetchTrainingDetails = async () => {
//                                     try {
//                                         const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
//                                         if (trainingDoc.exists()) {
//                                             return {
//                                                 trainingName: trainingDoc.data().name || "Unknown Training",
//                                                 trainingType: trainingDoc.data().type || "General",
//                                             };
//                                         } else {
//                                             toast.error("Training not found!");
//                                             return {
//                                                 trainingName: "Unknown Training",
//                                                 trainingType: "General",
//                                             };
//                                         }
//                                     } catch (error) {
//                                         toast.error("Error fetching training details: " + error.message);
//                                         return {
//                                             trainingName: "Unknown Training",
//                                             trainingType: "General",
//                                         };
//                                     }
//                                 };

//                                 const { trainingName, trainingType } = await fetchTrainingDetails();

//                                 // Adjust score and status for Declaration type
//                                 const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
//                                 const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
//                                 const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

//                                 return {
//                                     id: quizDoc.id,
//                                     name: trainingName,
//                                     score,
//                                     status,
//                                     completedAt: quizData.completedAt?.toDate().toLocaleDateString() || "N/A",
//                                     trainingType: adjustedTrainingType,
//                                 };
//                             })
//                         );

//                         return {
//                             id: userId,
//                             name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
//                             dob: userInfo.dob || "N/A",
//                             phone: userInfo.phone || "N/A",
//                             email: userInfo.email || "N/A",
//                             quizzes,
//                         };
//                     })
//                 );

//                 setUsers(usersData);
//             } catch (error) {
//                 console.error("Error fetching users and quizzes:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchUsersAndQuizzes();
//     }, []);

//     // Filter users and quizzes based on search terms
//     const filteredUsers = users.filter((user) => {
//         const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
//         return searchKeywords.every((keyword) =>
//             user.name.toLowerCase().includes(keyword) ||
//             user.dob.toLowerCase().includes(keyword) ||
//             user.phone.toLowerCase().includes(keyword) ||
//             user.email.toLowerCase().includes(keyword) ||
//             user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
//         );
//     });

//     if (loading) {
//         return <div>Loading...</div>;
//     }

//     return (
      
//         <div className="container mt-4">
//             <h2 className="text-center mb-4">Training Results Dashboard</h2>
//             <p className="text-muted text-center">Search and review training results by learner or training details.</p>

//             {/* Search Bar */}
//             <div className="d-flex justify-content-center mb-4">
//                 <input
//                     type="text"
//                     className="form-control w-50"
//                     placeholder="Search by Name, DOB, Email, Phone, or Training Name"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//                 <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
//                     Clear
//                 </button>
//             </div>

//             {/* Display User Cards */}
//             {filteredUsers.length === 0 ? (
//                 <p className="text-center">No users found. Try adjusting your search.</p>
//             ) : (
//                 filteredUsers.map((user) => (
//                     <div key={user.id} className="card mb-4">
//                         <div className="card-header bg-primary text-white">
//                             <h5 className="mb-0">{user.name}</h5>
//                         </div>
//                         <div className="card-body">
//                             {/* User Information */}
//                             <div className="row mb-3">
//                                 <div className="col-md-4">
//                                     <p><strong>Date of Birth:</strong> {user.dob}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Phone:</strong> {user.phone}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Email:</strong> {user.email}</p>
//                                 </div>
//                             </div>

//                             {/* Training Results */}
//                             {user.quizzes.length === 0 ? (
//                                 <p className="text-muted">No training records available.</p>
//                             ) : (
//                                 <div>
//                                     <h6>Training Records:</h6>
//                                     <table className="table table-striped">
//                                         <thead>
//                                             <tr>
//                                                 <th>Training Name</th>
//                                                 <th>Type</th>
//                                                 <th>Score</th>
//                                                 <th>Status</th>
//                                                 <th>Completed At</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {user.quizzes.map((quiz) => (
//                                                 <tr key={quiz.id}>
//                                                     <td>{quiz.name}</td>
//                                                     <td>{quiz.trainingType}</td>
//                                                     <td>{quiz.score}</td>
//                                                     <td>
//                                                         <span
//                                                             className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
//                                                                     ? "bg-success"
//                                                                     : "bg-danger"
//                                                                 }`}
//                                                         >
//                                                             {quiz.status}
//                                                         </span>
//                                                     </td>
//                                                     <td>{quiz.completedAt}</td>
//                                                     <td>
//                                                         <button
//                                                             className="btn btn-outline-primary btn-sm"
//                                                             onClick={() =>
//                                                                 navigate(`/view-training-result/${user.id}/${quiz.id}`)
//                                                             }
//                                                         >
//                                                             View
//                                                         </button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 ))
//             )}
//         </div>




//     );


// };

// export default ViewResults;













// import React, { useState, useEffect } from "react";
// import { db } from "../firebase"; // Firebase configuration
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom"; // Import navigation hook
// import { toast } from "react-toastify";

// const ViewResults = () => {
//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState(""); // Search term state
//     const navigate = useNavigate(); // Initialize the navigation hook

//     useEffect(() => {
//         const fetchUsersAndQuizzes = async () => {
//             setLoading(true);
//             try {
//                 const usersCollectionRef = collection(db, "users");
//                 const usersSnapshot = await getDocs(usersCollectionRef);

//                 const usersData = await Promise.all(
//                     usersSnapshot.docs.map(async (userDoc) => {
//                         const userId = userDoc.id;
//                         const userInfo = userDoc.data();

//                         // Fetch quizzes for the user
//                         const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
//                         const quizzesSnapshot = await getDocs(quizzesCollectionRef);

//                         // Process quiz data
//                         const quizzes = await Promise.all(
//                             quizzesSnapshot.docs.map(async (quizDoc) => {
//                                 const quizData = quizDoc.data();

//                                 // Fetch training details
//                                 const fetchTrainingDetails = async () => {
//                                     try {
//                                         const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
//                                         if (trainingDoc.exists()) {
//                                             return {
//                                                 trainingName: trainingDoc.data().name || "Unknown Training",
//                                                 trainingType: trainingDoc.data().type || "General",
//                                             };
//                                         } else {
//                                             toast.error("Training not found!");
//                                             return {
//                                                 trainingName: "Unknown Training",
//                                                 trainingType: "General",
//                                             };
//                                         }
//                                     } catch (error) {
//                                         toast.error("Error fetching training details: " + error.message);
//                                         return {
//                                             trainingName: "Unknown Training",
//                                             trainingType: "General",
//                                         };
//                                     }
//                                 };

//                                 const { trainingName, trainingType } = await fetchTrainingDetails();

//                                 // Fetch feedback for the quiz (located at /users/{userId}/feedback/{trainingId})
//                                 const fetchFeedback = async () => {
//                                     try {
//                                         const feedbackDocRef = doc(db, "users", userId, "feedback", quizDoc.id);  // feedback is stored with quizId
//                                         const feedbackDoc = await getDoc(feedbackDocRef);
//                                         return feedbackDoc.exists() ? feedbackDoc.data().feedback : null;
//                                     } catch (error) {
//                                         toast.error("Error fetching feedback: " + error.message);
//                                         return null;
//                                     }
//                                 };

//                                 const feedback = await fetchFeedback();

//                                 // Adjust score and status for Declaration type
//                                 const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
//                                 const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
//                                 const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

//                                 return {
//                                     id: quizDoc.id,
//                                     name: trainingName,
//                                     score,
//                                     status,
//                                     completedAt: quizData.completedAt?.toDate().toLocaleDateString() || "N/A",
//                                     trainingType: adjustedTrainingType,
//                                     feedback,
//                                 };
//                             })
//                         );

//                         return {
//                             id: userId,
//                             name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
//                             dob: userInfo.dob || "N/A",
//                             phone: userInfo.phone || "N/A",
//                             email: userInfo.email || "N/A",
//                             quizzes,
//                         };
//                     })
//                 );

//                 setUsers(usersData);
//             } catch (error) {
//                 console.error("Error fetching users and quizzes:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchUsersAndQuizzes();
//     }, []);

//     // Filter users and quizzes based on search terms
//     const filteredUsers = users.filter((user) => {
//         const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
//         return searchKeywords.every((keyword) =>
//             user.name.toLowerCase().includes(keyword) ||
//             user.dob.toLowerCase().includes(keyword) ||
//             user.phone.toLowerCase().includes(keyword) ||
//             user.email.toLowerCase().includes(keyword) ||
//             user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
//         );
//     });

//     if (loading) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <div className="container mt-4">
//             <h2 className="text-center mb-4">Training Results Dashboard</h2>
//             <p className="text-muted text-center">Search and review training results by learner or training details.</p>

//             {/* Search Bar */}
//             <div className="d-flex justify-content-center mb-4">
//                 <input
//                     type="text"
//                     className="form-control w-50"
//                     placeholder="Search by Name, DOB, Email, Phone, or Training Name"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//                 <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
//                     Clear
//                 </button>
//             </div>

//             {/* Display User Cards */}
//             {filteredUsers.length === 0 ? (
//                 <p className="text-center">No users found. Try adjusting your search.</p>
//             ) : (
//                 filteredUsers.map((user) => (
//                     <div key={user.id} className="card mb-4">
//                         <div className="card-header bg-primary text-white">
//                             <h5 className="mb-0">{user.name}</h5>
//                         </div>
//                         <div className="card-body">
//                             {/* User Information */}
//                             <div className="row mb-3">
//                                 <div className="col-md-4">
//                                     <p><strong>Date of Birth:</strong> {user.dob}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Phone:</strong> {user.phone}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Email:</strong> {user.email}</p>
//                                 </div>
//                             </div>

//                             {/* Training Results */}
//                             {user.quizzes.length === 0 ? (
//                                 <p className="text-muted">No training records available.</p>
//                             ) : (
//                                 <div>
//                                     <h6>Training Records:</h6>
//                                     <table className="table table-striped">
//                                         <thead>
//                                             <tr>
//                                                 <th>Training Name</th>
//                                                 <th>Type</th>
//                                                 <th>Score</th>
//                                                 <th>Status</th>
//                                                 <th>Completed At</th>
//                                                 <th>Feedback</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {user.quizzes.map((quiz) => (
//                                                 <tr key={quiz.id}>
//                                                     <td>{quiz.name}</td>
//                                                     <td>{quiz.trainingType}</td>
//                                                     <td>{quiz.score}</td>
//                                                     <td>
//                                                         <span
//                                                             className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
//                                                                     ? "bg-success"
//                                                                     : "bg-danger"
//                                                                 }`}
//                                                         >
//                                                             {quiz.status}
//                                                         </span>
//                                                     </td>
//                                                     <td>{quiz.completedAt}</td>
//                                                     <td>
//                                                         {quiz.feedback ? (
//                                                             <button
//                                                                 className="btn btn-outline-secondary btn-sm"
//                                                                 onClick={() =>
//                                                                     navigate(`/view-feedback/${user.id}/${quiz.id}`)
//                                                                 }
//                                                             >
//                                                                 View Feedback
//                                                             </button>
//                                                         ) : (
//                                                             <span>No Feedback</span>
//                                                         )}
//                                                     </td>
//                                                     <td>
//                                                         <button
//                                                             className="btn btn-outline-primary btn-sm"
//                                                             onClick={() =>
//                                                                 navigate(`/view-training-result/${user.id}/${quiz.id}`)
//                                                             }
//                                                         >
//                                                             View
//                                                         </button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 ))
//             )}
//         </div>
//     );
// };

// export default ViewResults;












// import React, { useState, useEffect } from "react";
// import { db } from "../firebase"; // Firebase configuration
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom"; // Import navigation hook
// import { toast } from "react-toastify";

// const ViewResults = () => {
//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState(""); // Search term state
//     const navigate = useNavigate(); // Initialize the navigation hook

//     useEffect(() => {
//         const fetchUsersAndQuizzes = async () => {
//             setLoading(true);
//             try {
//                 const usersCollectionRef = collection(db, "users");
//                 const usersSnapshot = await getDocs(usersCollectionRef);

//                 const usersData = await Promise.all(
//                     usersSnapshot.docs.map(async (userDoc) => {
//                         const userId = userDoc.id;
//                         const userInfo = userDoc.data();

//                         // Fetch quizzes for the user
//                         const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
//                         const quizzesSnapshot = await getDocs(quizzesCollectionRef);


//                         // Process quiz data
//                         const quizzes = await Promise.all(
//                             quizzesSnapshot.docs.map(async (quizDoc) => {
//                                 const quizData = quizDoc.data();

//                                 // Fetch training details
//                                 const fetchTrainingDetails = async () => {
//                                     try {
//                                         const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
//                                         if (trainingDoc.exists()) {
//                                             return {
//                                                 trainingName: trainingDoc.data().name || "Unknown Training",
//                                                 trainingType: trainingDoc.data().type || "General",
//                                             };
//                                         } else {
//                                             toast.error("Training not found!");
//                                             return {
//                                                 trainingName: "Unknown Training",
//                                                 trainingType: "General",
//                                             };
//                                         }
//                                     } catch (error) {
//                                         toast.error("Error fetching training details: " + error.message);
//                                         return {
//                                             trainingName: "Unknown Training",
//                                             trainingType: "General",
//                                         };
//                                     }
//                                 };

//                                 const { trainingName, trainingType } = await fetchTrainingDetails();

//                                 // Fetch feedback for the quiz (located at /users/{userId}/feedback/{trainingId})
//                                 const fetchFeedback = async () => {
//                                     try {
//                                         const feedbackRef = doc(db, "users", userId, "feedback", quizDoc.id);  // feedback is stored with quizId
//                                         const feedbackDoc = await getDoc(feedbackRef);
//                                         return feedbackDoc.exists() ? feedbackDoc.data().feedback : null;
//                                     } catch (error) {
//                                         toast.error("Error fetching feedback: " + error.message);
//                                         return null;
//                                     }
//                                 };

//                                 const feedback = await fetchFeedback();

//                                 // Adjust score and status for Declaration type
//                                 const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
//                                 const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
//                                 const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

//                                 return {
//                                     id: quizDoc.id,
//                                     name: trainingName,
//                                     score,
//                                     status,
//                                     completedAt: quizData.completedAt?.toDate().toLocaleDateString() || "N/A",
//                                     trainingType: adjustedTrainingType,
//                                     feedback,
//                                 };
//                             })
//                         );

//                         return {
//                             id: userId,
//                             name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
//                             dob: userInfo.dob || "N/A",
//                             phone: userInfo.phone || "N/A",
//                             email: userInfo.email || "N/A",
//                             quizzes,
//                         };
//                     })
//                 );

//                 setUsers(usersData);
//             } catch (error) {
//                 console.error("Error fetching users and quizzes:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchUsersAndQuizzes();
//     }, []);

//     // Filter users and quizzes based on search terms
//     const filteredUsers = users.filter((user) => {
//         const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
//         return searchKeywords.every((keyword) =>
//             user.name.toLowerCase().includes(keyword) ||
//             user.dob.toLowerCase().includes(keyword) ||
//             user.phone.toLowerCase().includes(keyword) ||
//             user.email.toLowerCase().includes(keyword) ||
//             user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
//         );
//     });

//     if (loading) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <div className="container mt-4">
//             <h2 className="text-center mb-4">Training Results Dashboard</h2>
//             <p className="text-muted text-center">Search and review training results by learner or training details.</p>

//             {/* Search Bar */}
//             <div className="d-flex justify-content-center mb-4">
//                 <input
//                     type="text"
//                     className="form-control w-50"
//                     placeholder="Search by Name, DOB, Email, Phone, or Training Name"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//                 <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
//                     Clear
//                 </button>
//             </div>

//             {/* Display User Cards */}
//             {filteredUsers.length === 0 ? (
//                 <p className="text-center">No users found. Try adjusting your search.</p>
//             ) : (
//                 filteredUsers.map((user) => (
//                     <div key={user.id} className="card mb-4">
//                         <div className="card-header bg-primary text-white">
//                             <h5 className="mb-0">{user.name}</h5>
//                         </div>
//                         <div className="card-body">
//                             {/* User Information */}
//                             <div className="row mb-3">
//                                 <div className="col-md-4">
//                                     <p><strong>Date of Birth:</strong> {user.dob}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Phone:</strong> {user.phone}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Email:</strong> {user.email}</p>
//                                 </div>
//                             </div>

//                             {/* Training Results */}
//                             {user.quizzes.length === 0 ? (
//                                 <p className="text-muted">No training records available.</p>
//                             ) : (
//                                 <div>
//                                     <h6>Training Records:</h6>
//                                     <table className="table table-striped">
//                                         <thead>
//                                             <tr>
//                                                 <th>Training Name</th>
//                                                 <th>Type</th>
//                                                 <th>Score</th>
//                                                 <th>Status</th>
//                                                 <th>Completed At</th>
//                                                 <th>Feedback</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {user.quizzes.map((quiz) => (
//                                                 <tr key={quiz.id}>
//                                                     <td>{quiz.name}</td>
//                                                     <td>{quiz.trainingType}</td>
//                                                     <td>{quiz.score}</td>
//                                                     <td>
//                                                         <span
//                                                             className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
//                                                                     ? "bg-success"
//                                                                     : "bg-danger"
//                                                                 }`}
//                                                         >
//                                                             {quiz.status}
//                                                         </span>
//                                                     </td>
//                                                     <td>{quiz.completedAt}</td>
//                                                     <td>
                                                        
//                                                         {quiz.feedback ? (
//                                                             <button
//                                                                 className="btn btn-outline-secondary btn-sm"
//                                                                 onClick={() =>
//                                                                     navigate(`/view-feedback/${user.id}/${quiz.id}`)
//                                                                 }
//                                                             >
//                                                                 View Feedback
//                                                             </button>
//                                                         ) : (
//                                                             <span>No Feedback</span>
//                                                         )}
//                                                     </td>
//                                                     <td>
//                                                         <button
//                                                             className="btn btn-outline-primary btn-sm"
//                                                             onClick={() =>
//                                                                 navigate(`/view-training-result/${user.id}/${quiz.id}`)
//                                                             }
//                                                         >
//                                                             View
//                                                         </button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 ))
//             )}
//         </div>
//     );
// };

// export default ViewResults;









// import React, { useState, useEffect } from "react";
// import { db } from "../firebase"; // Firebase configuration
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom"; // Import navigation hook
// import { toast } from "react-toastify";

// const ViewResults = () => {
//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState(""); // Search term state
//     const navigate = useNavigate(); // Initialize the navigation hook

//     useEffect(() => {
//         const fetchUsersAndQuizzes = async () => {
//             setLoading(true);
//             try {
//                 const usersCollectionRef = collection(db, "users");
//                 const usersSnapshot = await getDocs(usersCollectionRef);

//                 const usersData = await Promise.all(
//                     usersSnapshot.docs.map(async (userDoc) => {
//                         const userId = userDoc.id;
//                         const userInfo = userDoc.data();

//                         // Fetch quizzes for the user
//                         const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
//                         const quizzesSnapshot = await getDocs(quizzesCollectionRef);

//                         // Process quiz data
//                         const quizzes = await Promise.all(
//                             quizzesSnapshot.docs.map(async (quizDoc) => {
//                                 const quizData = quizDoc.data();

//                                 // Fetch training details
//                                 const fetchTrainingDetails = async () => {
//                                     try {
//                                         const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
//                                         if (trainingDoc.exists()) {
//                                             return {
//                                                 trainingName: trainingDoc.data().name || "Unknown Training",
//                                                 trainingType: trainingDoc.data().type || "General",
//                                             };
//                                         } else {
//                                             toast.error("Training not found!");
//                                             return {
//                                                 trainingName: "Unknown Training",
//                                                 trainingType: "General",
//                                             };
//                                         }
//                                     } catch (error) {
//                                         toast.error("Error fetching training details: " + error.message);
//                                         return {
//                                             trainingName: "Unknown Training",
//                                             trainingType: "General",
//                                         };
//                                     }
//                                 };

                               

//                                 const { trainingName, trainingType } = await fetchTrainingDetails();

                               
//                                 // Fetch feedback for the quiz (located at /users/{userId}/feedback/{quizId})
//                                 const fetchFeedback = async () => {
//                                     try {
//                                         const feedbackRef = doc(db, "users", userId, "feedback");  // feedback is stored with quizId
//                                         const feedbackDoc = await getDoc(feedbackRef);
//                                         return feedbackDoc.exists() ? feedbackDoc.data().feedback : null;
                                        
//                                     } catch (error) {
//                                         toast.error("Error fetching feedback: " + error.message);
//                                         return null;
//                                     }
//                                 };

//                                 const feedback = await fetchFeedback();
                                

                               
//                                 // Adjust score and status for Declaration type
//                                 const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
//                                 const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
//                                 const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

//                                 return {
//                                     id: quizDoc.id,
//                                     name: trainingName,
//                                     score,
//                                     status,
//                                     completedAt: quizData.completedAt?.toDate().toLocaleDateString() || "N/A",
//                                     trainingType: adjustedTrainingType,
//                                     feedback, // Store feedback here after fetching
//                                 };
//                             })
//                         );

                        
//                         return {
//                             id: userId,
//                             name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
//                             dob: userInfo.dob || "N/A",
//                             phone: userInfo.phone || "N/A",
//                             email: userInfo.email || "N/A",
//                             quizzes,
//                         };
//                     })
//                 );

//                 setUsers(usersData);
//             } catch (error) {
//                 console.error("Error fetching users and quizzes:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchUsersAndQuizzes();
//     }, []);

//     // Filter users and quizzes based on search terms
//     const filteredUsers = users.filter((user) => {
//         const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
//         return searchKeywords.every((keyword) =>
//             user.name.toLowerCase().includes(keyword) ||
//             user.dob.toLowerCase().includes(keyword) ||
//             user.phone.toLowerCase().includes(keyword) ||
//             user.email.toLowerCase().includes(keyword) ||
//             user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
//         );
//     });

//     if (loading) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <div className="container mt-4">
//             <h2 className="text-center mb-4">Training Results Dashboard</h2>
//             <p className="text-muted text-center">Search and review training results by learner or training details.</p>

//             {/* Search Bar */}
//             <div className="d-flex justify-content-center mb-4">
//                 <input
//                     type="text"
//                     className="form-control w-50"
//                     placeholder="Search by Name, DOB, Email, Phone, or Training Name"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//                 <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
//                     Clear
//                 </button>
//             </div>

//             {/* Display User Cards */}
//             {filteredUsers.length === 0 ? (
//                 <p className="text-center">No users found. Try adjusting your search.</p>
//             ) : (
//                 filteredUsers.map((user) => (
//                     <div key={user.id} className="card mb-4">
//                         <div className="card-header bg-primary text-white">
//                             <h5 className="mb-0">{user.name}</h5>
//                         </div>
//                         <div className="card-body">
//                             {/* User Information */}
//                             <div className="row mb-3">
//                                 <div className="col-md-4">
//                                     <p><strong>Date of Birth:</strong> {user.dob}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Phone:</strong> {user.phone}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Email:</strong> {user.email}</p>
//                                 </div>
//                             </div>

//                             {/* Training Results */}
//                             {user.quizzes.length === 0 ? (
//                                 <p className="text-muted">No training records available.</p>
//                             ) : (
//                                 <div>
//                                     <h6>Training Records:</h6>
//                                     <table className="table table-striped">
//                                         <thead>
//                                             <tr>
//                                                 <th>Training Name</th>
//                                                 <th>Type</th>
//                                                 <th>Score</th>
//                                                 <th>Status</th>
//                                                 <th>Completed At</th>
//                                                 <th>Feedback</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
                                            
//                                             {user.quizzes.map((quiz) => (
//                                                 <tr key={quiz.id}>
//                                                     <td>{quiz.name}</td>
//                                                     <td>{quiz.trainingType}</td>
//                                                     <td>{quiz.score}</td>
//                                                     <td>
//                                                         <span
//                                                             className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
//                                                                     ? "bg-success"
//                                                                     : "bg-danger"
//                                                                 }`}
//                                                         >
//                                                             {quiz.status}
//                                                         </span>
//                                                     </td>
//                                                     <td>{quiz.completedAt}</td>
//                                                     <td>
//                                                         {/* Display feedback if available */}
//                                                         {console.log(users)}
//                                                         {quiz.id ? (
//                                                             <button
//                                                                 className="btn btn-outline-secondary btn-sm"
//                                                                 onClick={() =>
//                                                                     navigate(`/view-feedback/${user.id}/${quiz.id}`)
//                                                                 }
//                                                             >
//                                                                 View Feedback
//                                                             </button>
//                                                         ) : (
//                                                             <span>No Feedback</span>
//                                                         )}
//                                                     </td>
//                                                     <td>
//                                                         <button
//                                                             className="btn btn-outline-primary btn-sm"
//                                                             onClick={() =>
//                                                                 navigate(`/view-training-result/${user.id}/${quiz.id}`)
//                                                             }
//                                                         >
//                                                             View
//                                                         </button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 ))
//             )}
//         </div>
//     );
// };

// export default ViewResults;















// import React, { useState, useEffect } from "react";
// import { db } from "../firebase"; // Firebase configuration
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom"; // Import navigation hook
// import { toast } from "react-toastify";

// const ViewResults = () => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState(""); // Search term state
//   const navigate = useNavigate(); // Initialize the navigation hook

//   useEffect(() => {
//     const fetchUsersAndQuizzes = async () => {
//       setLoading(true);
//       try {
//         const usersCollectionRef = collection(db, "users");
//         const usersSnapshot = await getDocs(usersCollectionRef);

//         const usersData = await Promise.all(
//           usersSnapshot.docs.map(async (userDoc) => {
//             const userId = userDoc.id;
//             const userInfo = userDoc.data();

//             // Fetch quizzes for the user
//             const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
//             const quizzesSnapshot = await getDocs(quizzesCollectionRef);

//             const quizzes = await Promise.all(
//               quizzesSnapshot.docs.map(async (quizDoc) => {
//                 const quizData = quizDoc.data();

//                 // Fetch training details (same logic as before)
//                 const fetchTrainingDetails = async () => {
//                   try {
//                     const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
//                     if (trainingDoc.exists()) {
//                       return {
//                         trainingName: trainingDoc.data().name || "Unknown Training",
//                         trainingType: trainingDoc.data().type || "General",
//                       };
//                     } else {
//                       toast.error("Training not found!");
//                       return {
//                         trainingName: "Unknown Training",
//                         trainingType: "General",
//                       };
//                     }
//                   } catch (error) {
//                     toast.error("Error fetching training details: " + error.message);
//                     return {
//                       trainingName: "Unknown Training",
//                       trainingType: "General",
//                     };
//                   }
//                 };

//                 const { trainingName, trainingType } = await fetchTrainingDetails();

//                 // Fetch feedback from feedback collection (same approach as ViewFeedbacks.js)
//                 const fetchFeedback = async () => {
//                   try {
//                     const feedbackRef = collection(db, "users", userId, "feedback");
//                     const feedbackSnap = await getDocs(feedbackRef);

//                     const feedbackData = [];
//                     feedbackSnap.forEach((feedbackDoc) => {
//                       feedbackData.push(feedbackDoc.data());
//                     });

//                     return feedbackData;
//                   } catch (error) {
//                     toast.error("Error fetching feedback: " + error.message);
//                     return [];
//                   }
//                 };

//                 const feedback = await fetchFeedback();

//                 // Adjust score and status for Declaration type
//                 const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
//                 const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
//                 const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

//                 return {
//                   id: quizDoc.id,
//                   name: trainingName,
//                   score,
//                   status,
//                   completedAt: quizData.completedAt?.toDate().toLocaleDateString() || "N/A",
//                   trainingType: adjustedTrainingType,
//                   feedback, // Store feedback here after fetching
//                 };
//               })
//             );

//             return {
//               id: userId,
//               name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
//               dob: userInfo.dob || "N/A",
//               phone: userInfo.phone || "N/A",
//               email: userInfo.email || "N/A",
//               quizzes,
//             };
//           })
//         );

//         setUsers(usersData);
//       } catch (error) {
//         console.error("Error fetching users and quizzes:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUsersAndQuizzes();
//   }, []);

//   // Filter users and quizzes based on search terms
//   const filteredUsers = users.filter((user) => {
//     const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
//     return searchKeywords.every((keyword) =>
//       user.name.toLowerCase().includes(keyword) ||
//       user.dob.toLowerCase().includes(keyword) ||
//       user.phone.toLowerCase().includes(keyword) ||
//       user.email.toLowerCase().includes(keyword) ||
//       user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
//     );
//   });

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className="container mt-4">
//       <h2 className="text-center mb-4">Training Results Dashboard</h2>
//       <p className="text-muted text-center">Search and review training results by learner or training details.</p>

//       {/* Search Bar */}
//       <div className="d-flex justify-content-center mb-4">
//         <input
//           type="text"
//           className="form-control w-50"
//           placeholder="Search by Name, DOB, Email, Phone, or Training Name"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//         <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
//           Clear
//         </button>
//       </div>

//       {/* Display User Cards */}
//       {filteredUsers.length === 0 ? (
//         <p className="text-center">No users found. Try adjusting your search.</p>
//       ) : (
//         filteredUsers.map((user) => (
//           <div key={user.id} className="card mb-4">
//             <div className="card-header bg-primary text-white">
//               <h5 className="mb-0">{user.name}</h5>
//             </div>
//             <div className="card-body">
//               {/* User Information */}
//               <div className="row mb-3">
//                 <div className="col-md-4">
//                   <p><strong>Date of Birth:</strong> {user.dob}</p>
//                 </div>
//                 <div className="col-md-4">
//                   <p><strong>Phone:</strong> {user.phone}</p>
//                 </div>
//                 <div className="col-md-4">
//                   <p><strong>Email:</strong> {user.email}</p>
//                 </div>
//               </div>

//               {/* Training Results */}
//               {user.quizzes.length === 0 ? (
//                 <p className="text-muted">No training records available.</p>
//               ) : (
//                 <div>
//                   <h6>Training Records:</h6>
//                   <table className="table table-striped">
//                     <thead>
//                       <tr>
//                         <th>Training Name</th>
//                         <th>Type</th>
//                         <th>Score</th>
//                         <th>Status</th>
//                         <th>Completed At</th>
//                         <th>Feedback</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {user.quizzes.map((quiz) => (
//                         <tr key={quiz.id}>
//                           <td>{quiz.name}</td>
//                           <td>{quiz.trainingType}</td>
//                           <td>{quiz.score}</td>
//                           <td>
//                             <span
//                               className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
//                                 ? "bg-success"
//                                 : "bg-danger"
//                               }`}
//                             >
//                               {quiz.status}
//                             </span>
//                           </td>
//                           <td>{quiz.completedAt}</td>
//                           <td>
//                             {/* Display feedback if available */}
//                             {quiz.feedback.length > 0 ? (
//                               <button
//                                 className="btn btn-outline-secondary btn-sm"
//                                 onClick={() =>
//                                   navigate(`/view-feedback/${user.id}/${quiz.id}`)
//                                 }
//                               >
//                                 View Feedback
//                               </button>
//                             ) : (
//                               <span>No Feedback</span>
//                             )}
//                           </td>
//                           <td>
//                             <button
//                               className="btn btn-outline-primary btn-sm"
//                               onClick={() =>
//                                 navigate(`/view-training-result/${user.id}/${quiz.id}`)
//                               }
//                             >
//                               View
//                             </button>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           </div>
//         ))
//       )}
//     </div>
//   );
// };

// export default ViewResults;












import React, { useState, useEffect } from "react";
import { db } from "../firebase"; // Firebase configuration
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom"; // Import navigation hook
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";

const ViewResults = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const navigate = useNavigate(); // Initialize the navigation hook

  useEffect(() => {
    const fetchUsersAndQuizzes = async () => {
      setLoading(true);
      try {
        const usersCollectionRef = collection(db, "users");
        const usersSnapshot = await getDocs(usersCollectionRef);

        const usersData = await Promise.all(
          usersSnapshot.docs.map(async (userDoc) => {
            const userId = userDoc.id;
            const userInfo = userDoc.data();

            // Fetch quizzes for the user
            const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
            const quizzesSnapshot = await getDocs(quizzesCollectionRef);

            const quizzes = await Promise.all(
              quizzesSnapshot.docs.map(async (quizDoc) => {
                const quizData = quizDoc.data();

                // Fetch training details (same logic as before)
                const fetchTrainingDetails = async () => {
                  try {
                    const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
                    if (trainingDoc.exists()) {
                      return {
                        trainingName: trainingDoc.data().name || "Unknown Training",
                        trainingType: trainingDoc.data().type || "General",
                      };
                    } else {
                      toast.error("Training not found!");
                      return {
                        trainingName: "Unknown Training",
                        trainingType: "General",
                      };
                    }
                  } catch (error) {
                    toast.error("Error fetching training details: " + error.message);
                    return {
                      trainingName: "Unknown Training",
                      trainingType: "General",
                    };
                  }
                };

                const { trainingName, trainingType } = await fetchTrainingDetails();

                // Fetch feedback from feedback collection (this part has been modified)
                const fetchFeedback = async () => {
                  try {
                    const feedbackRef = collection(db, "users", userId, "feedback");
                    const feedbackSnap = await getDocs(feedbackRef);

                    // Collect feedback data
                    let feedbackData = null;
                    feedbackSnap.forEach((feedbackDoc) => {
                      if (feedbackDoc.id === quizDoc.id) {
                        feedbackData = feedbackDoc.data();
                      }
                    });

                    return feedbackData;
                  } catch (error) {
                    toast.error("Error fetching feedback: " + error.message);
                    return null;
                  }
                };

                const feedback = await fetchFeedback();

                // Adjust score and status for Declaration type
                const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
                const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
                const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

                

                return {
                  id: quizDoc.id,
                  name: trainingName,
                  score,
                  status,
                  completedAt: quizData.completedAt,
                  trainingType: adjustedTrainingType,
                  feedback, // Store the actual feedback here
                };
              })
            );

            return {
              id: userId,
              name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
              dob: userInfo.dob || "N/A",
              phone: userInfo.phone || "N/A",
              email: userInfo.email || "N/A",
              quizzes,
            };
          })
        );

        setUsers(usersData);
      } catch (error) {
        console.error("Error fetching users and quizzes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsersAndQuizzes();
  }, []);


  const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty or undefined date
    const date = new Date(dateString);  // Convert string to Date object

    const day = String(date.getDate()).padStart(2, '0');  // Get day and ensure 2 digits
    const month = String(date.getMonth() + 1).padStart(2, '0');  // Get month (0-based, so add 1) and ensure 2 digits
    const year = date.getFullYear();  // Get year

    return `${day}/${month}/${year}`;  // Return formatted date as dd/mm/yyyy
  };

  // Filter users and quizzes based on search terms
  const filteredUsers = users.filter((user) => {
    const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
    return searchKeywords.every((keyword) =>
      user.name.toLowerCase().includes(keyword) ||
      user.dob.toLowerCase().includes(keyword) ||
      user.phone.toLowerCase().includes(keyword) ||
      user.email.toLowerCase().includes(keyword) ||
      user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
    );
  });

  if (loading) {
    return <div><div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
    <Spinner animation="border" variant="primary" />
  </div></div>;
  }

  return (
    <div className="container mt-4">
      <h2 className="text-center mb-4">Training Results Dashboard</h2>
      <p className="text-muted text-center">Search and review training results by learner or training details.</p>

      {/* Search Bar */}
      <div className="d-flex justify-content-center mb-4">
        <input
          type="text"
          className="form-control w-50"
          placeholder="Search by Name, DOB, Email, Phone, or Training Name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
          Clear
        </button>
      </div>

      {/* Display User Cards */}
      {filteredUsers.length === 0 ? (
        <p className="text-center">No users found. Try adjusting your search.</p>
      ) : (
        filteredUsers.map((user) => (
          <div key={user.id} className="card mb-4">
            <div className="card-header bg-primary text-white">
              <h5 className="mb-0">{user.name}</h5>
            </div>
            <div className="card-body">
              {/* User Information */}
              <div className="row mb-3">
                <div className="col-md-4">
                  <p><strong>Date of Birth:</strong> {user.dob}</p>
                </div>
                <div className="col-md-4">
                  <p><strong>Phone:</strong> {user.phone}</p>
                </div>
                <div className="col-md-4">
                  <p><strong>Email:</strong> {user.email}</p>
                </div>
              </div>

              {/* Training Results */}
              {user.quizzes.length === 0 ? (
                <p className="text-muted">No training records available.</p>
              ) : (
                <div>
                  <h6>Training Records:</h6>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Training Name</th>
                        <th>Type</th>
                        <th>Score</th>
                        <th>Status</th>
                        <th>Completed At</th>
                        <th>Feedback</th>
                        <th>Download</th>
                        <th>Retakes</th>
                      </tr>
                    </thead>
                    <tbody>
                      {user.quizzes.map((quiz) => (
                        <tr key={quiz.id}>
                          <td>{quiz.name}</td>
                          <td>{quiz.trainingType}</td>
                          <td>{quiz.score}</td>
                          <td>
                            <span
                              className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
                                ? "bg-success"
                                : "bg-danger"
                              }`}
                            >
                              {quiz.status}
                            </span>
                          </td>
                          <td>{formatDate(quiz.completedAt)}</td>
                          <td>
                            {/* Display feedback if available */}
                            {quiz.feedback ? (
                              <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() =>
                                  navigate(`/view-feedback/${user.id}/${quiz.id}`)
                                }
                              >
                                View Feedback
                              </button>
                            ) : (
                              <span>No Feedback</span>
                            )}
                          </td>
                          <td>
                            <button
                              className="btn btn-outline-primary btn-sm"
                              onClick={() =>
                                navigate(`/view-training-result/${user.id}/${quiz.id}`)
                              }
                            >
                              Download
                            </button>
                          </td>
                          <td>
                           <button
                              className="btn btn-outline-primary btn-sm"
                              onClick={() =>
                                navigate(`/view-retake-training-result/${user.id}/${quiz.id}`)
                              }
                            > 
                            Download Retake
                            </button> 
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ViewResults;
